import { useTranslation } from 'react-i18next'
import { datadogRum } from '@datadog/browser-rum'
import { Button } from 'ui/src/components/Button/Button'
import { Dialog } from 'ui/src/components/Dialog/Dialog'
import { FullscreenDialog } from 'ui/src/components/Dialog/FullscreenDialog'
import { Text } from 'ui/src/components/Text/Text'
import { BankIdIcon } from 'ui/src/icons/BankIdIcon'
import { WarningTriangleIcon } from 'ui/src/icons/WarningTriangleIcon'
import { xStack, yStack } from 'ui/src/patterns/stack'
import { tokens } from 'ui/src/theme/tokens.css'

type Props = {
  onConfirm: () => void
}

export const ConfirmPayWithoutExtensionButton = (props: Props) => {
  const { t } = useTranslation(['common', 'carDealership'])

  const handleClick = () => {
    datadogRum.addAction('Car dearlership | Confirm pay without extension')
    props.onConfirm()
  }

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild={true}>
        <Button variant="primary" size="large" fullWidth={true}>
          <div className={xStack({ gap: 'xs' })}>
            <BankIdIcon />
            {t('carDealership:CONNECT_PAYMENT_BUTTON')}
          </div>
        </Button>
      </Dialog.Trigger>

      <FullscreenDialog.Modal
        accessibleCloseLabel={t('common:DIALOG_CLOSE')}
        center={true}
        Footer={
          <>
            <Button size="large" onClick={handleClick} fullWidth={true}>
              {t('carDealership:PAY_WITHOUT_EXTENSION_DIALOG_CONFIRM')}
            </Button>
            <Dialog.Close asChild={true}>
              <Button type="button" variant="ghost" size="large" fullWidth={true}>
                {t('carDealership:PAY_WITHOUT_EXTENSION_DIALOG_CANCEL')}
              </Button>
            </Dialog.Close>
          </>
        }
      >
        <div className={yStack({ gap: 'md', alignItems: 'center' })}>
          <WarningTriangleIcon size="1.5rem" color={tokens.legacyColors.signalAmberElement} />
          <div style={{ maxWidth: '38rem', marginInline: 'auto' }}>
            <Text size={{ _: 'md', lg: 'xl' }} align="center">
              {t('carDealership:PAY_WITHOUT_EXTENSION_DIALOG_TITLE')}
            </Text>
            <Text size={{ _: 'md', lg: 'xl' }} color="textSecondary" align="center" balance={true}>
              {t('carDealership:PAY_WITHOUT_EXTENSION_DIALOG_SUBTITLE')}
            </Text>
          </div>
        </div>
      </FullscreenDialog.Modal>
    </Dialog.Root>
  )
}
